import { useState, useEffect } from "react";

import {
  fetchKnowledgePublications,
  getPublicationDetailUrl,
} from "./knowledgePublicationApi";

/* ------------------------------ inline icons ------------------------------ */

function IconGrid({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </svg>
  );
}

function IconLayers({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <polygon points="12 2 2 7 12 12 22 7 12 2" />
      <polyline points="2 17 12 22 22 17" />
      <polyline points="2 12 12 17 22 12" />
    </svg>
  );
}

function IconChevronLeft({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <polyline points="15 18 9 12 15 6" />
    </svg>
  );
}

function IconChevronRight({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );
}

function IconCalendar({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );
}

function IconLock({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <rect x="4" y="10" width="16" height="11" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    </svg>
  );
}

function IconDoc({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
    </svg>
  );
}

/* --------------------------- grid card (new design) ------------------------ */

function KnowledgeCard({ item }) {
  return (
    <a
      href={getPublicationDetailUrl(item)}
      target="_blank"
      rel="noopener noreferrer"
      className="card-hover"
      style={{
        background: "#FFFFFF",
        borderRadius: 24,
        overflow: "hidden",
        position: "relative",
        border: "1px solid #ececec",
        boxShadow: "0 10px 25px rgba(0,0,0,0.06)",
        transition: "0.35s ease",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        textDecoration: "none",
      }}
    >
      {/* crown-shaped header decoration */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: 90,
          background:
            "linear-gradient(135deg, rgb(98, 94, 94) 0%, rgb(96, 96, 96) 50%, rgb(152, 146, 146) 100%)",
          clipPath: "polygon(0 0, 100% 0, 100% 72%, 85% 100%, 60% 80%, 35% 100%, 0 72%)",
          zIndex: 0,
        }}
      />

      {/* circular blur badge */}
      <div
        style={{
          position: "absolute",
          top: 18,
          right: 18,
          width: 48,
          height: 48,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.15)",
          backdropFilter: "blur(6px)",
          zIndex: 1,
        }}
      />

      {/* date badge over the crown */}
      <div style={{ position: "absolute", zIndex: 5, padding: "14px 20px 0" }}>
        <div
          style={{
            background: "rgba(255,255,255,0.92)",
            borderRadius: 10,
            padding: "4px 10px",
            display: "inline-flex",
            flexDirection: "column",
            alignItems: "center",
            lineHeight: 1.1,
            boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
          }}
        >
          <span style={{ fontSize: 14, fontWeight: 800, color: "#8b0f1a" }}>{item.day}</span>
          <span style={{ fontSize: 9, fontWeight: 700, color: "#888", textTransform: "uppercase" }}>
            {item.month} {item.year}
          </span>
        </div>
      </div>

      {/* image */}
      <div style={{ position: "relative", padding: "16px 20px 0", zIndex: 2 }}>
        <div style={{ borderRadius: 18, overflow: "hidden", boxShadow: "0 8px 20px rgba(0,0,0,0.12)" }}>
          {item.image ? (
            <img
              src={item.image}
              alt={item.title}
              style={{ width: "100%", position: "relative", objectFit: "cover", display: "block" }}
            />
          ) : (
            <div
              style={{
                width: "100%",
                height: 200,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#FAF7F2",
                color: "#f7941d",
              }}
            >
              <IconDoc className="w-10 h-10" />
            </div>
          )}
        </div>
      </div>

      {/* content */}
      <div
        style={{
          padding: "18px 20px 22px",
          position: "relative",
          zIndex: 2,
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            fontSize: 15,
            fontWeight: 700,
            color: "#222",
            lineHeight: 1.4,
            marginBottom: 8,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {item.title}
        </div>

        {item.paidAccess && (
          <div style={{ fontSize: 12, color: "#8b0f1a", fontWeight: 700, marginBottom: 10 }}>
            🔒 Members Only
          </div>
        )}

        <span
          className="bg-white hover:bg-[#f7941d] transition-colors duration-300 hover:text-white text-[#8b0f1a]"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            border: "2px solid #f7941d",
            padding: "11px 18px",
            borderRadius: 100,
            fontSize: 12,
            fontWeight: 700,
            transition: "0.3s",
            boxShadow: "0 6px 14px rgba(247,148,29,0.25)",
            marginTop: "auto",
            width: "fit-content",
          }}
        >
          {item.paidAccess ? "View Details →" : "Read Publication →"}
        </span>
      </div>
    </a>
  );
}

/* ------------------------------ pagination (1 2 3 … last) ------------------- */

function buildPageList(current, total) {
  const delta = 1;
  const range = [];
  const withDots = [];
  let last;
  for (let i = 1; i <= total; i++) {
    if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
      range.push(i);
    }
  }
  range.forEach((i) => {
    if (last) {
      if (i - last === 2) withDots.push(last + 1);
      else if (i - last !== 1) withDots.push("...");
    }
    withDots.push(i);
    last = i;
  });
  return withDots;
}

function GridPagination({ page, totalPages, onChange }) {
  if (totalPages <= 1) return null;
  const pages = buildPageList(page, totalPages);

  return (
    <div className="mt-10 flex items-center justify-center gap-1.5 flex-wrap">
      <button
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        aria-label="Previous page"
        className="w-9 h-9 rounded-full grid place-items-center bg-white ring-1 ring-orange-200/40 text-gray-600 hover:text-red-700 hover:ring-orange-400/60 disabled:opacity-40 disabled:pointer-events-none transition-all"
      >
        <IconChevronLeft className="w-4 h-4" />
      </button>

      {pages.map((p, i) =>
        p === "..." ? (
          <span key={`dots-${i}`} className="w-9 h-9 grid place-items-center text-gray-400 text-sm">…</span>
        ) : (
          <button
            key={p}
            onClick={() => onChange(p)}
            className={`w-9 h-9 rounded-full text-[13px] font-semibold transition-all duration-200 ${
              p === page
                ? "bg-gradient-to-r from-red-700 to-orange-600 text-white shadow-sm shadow-red-700/30"
                : "bg-white ring-1 ring-orange-200/40 text-gray-600 hover:text-red-700 hover:ring-orange-400/60"
            }`}
          >
            {p}
          </button>
        )
      )}

      <button
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        aria-label="Next page"
        className="w-9 h-9 rounded-full grid place-items-center bg-white ring-1 ring-orange-200/40 text-gray-600 hover:text-red-700 hover:ring-orange-400/60 disabled:opacity-40 disabled:pointer-events-none transition-all"
      >
        <IconChevronRight className="w-4 h-4" />
      </button>
    </div>
  );
}

/* -------------------------------- slider ----------------------------------- */

function KnowledgeSlider({ items }) {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const total = items.length;

  useEffect(() => {
    if (paused || total <= 1) return;
    const t = setInterval(() => setIndex((i) => (i + 1) % total), 5000);
    return () => clearInterval(t);
  }, [paused, total]);

  if (total === 0) {
    return (
      <div className="grid place-items-center py-20 text-gray-400 text-sm rounded-2xl bg-white ring-1 ring-orange-200/30">
        No publications found.
      </div>
    );
  }

  const goTo = (i) => setIndex(((i % total) + total) % total);
  const next = () => goTo(index + 1);
  const prev = () => goTo(index - 1);

  return (
    <div
      className="relative rounded-2xl overflow-hidden ring-1 ring-orange-200/30 bg-gray-900 shadow-lg"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div
        className="flex transition-transform duration-700 ease-out"
        style={{ transform: `translateX(-${index * 100}%)` }}
      >
        {items.map((item) => (
          <a
            key={item.id}
            href={getPublicationDetailUrl(item)}
            target="_blank"
            rel="noopener noreferrer"
            className="relative w-full shrink-0 block"
          >
            <div className="relative w-full aspect-[16/7] bg-[#111]">
              {item.image ? (
                <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full grid place-items-center text-orange-300">
                  <IconDoc className="w-12 h-12" />
                </div>
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />

              <div className="absolute left-5 bottom-5 right-24 sm:right-28">
                <div className="inline-flex items-center gap-1.5 rounded-full bg-white/15 backdrop-blur px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-white">
                  <IconCalendar className="w-3.5 h-3.5" />
                  {item.day} {item.month} {item.year}
                  {item.paidAccess && (
                    <>
                      <span className="mx-1 opacity-50">·</span>
                      <IconLock className="w-3 h-3" /> Members Only
                    </>
                  )}
                </div>
                <h3 className="mt-3 font-display text-white text-lg sm:text-2xl leading-snug line-clamp-2">
                  {item.title}
                </h3>
              </div>
            </div>
          </a>
        ))}
      </div>

      {/* top-right animated controls */}
      <div className="absolute top-4 right-4 flex items-center gap-2 rounded-full bg-black/30 backdrop-blur-md p-1.5">
        <button
          onClick={(e) => { e.preventDefault(); prev(); }}
          aria-label="Previous"
          className="w-9 h-9 rounded-full grid place-items-center text-white bg-white/10 hover:bg-gradient-to-r hover:from-red-700 hover:to-orange-600 transition-all duration-300 hover:-translate-x-0.5"
        >
          <IconChevronLeft className="w-4 h-4" />
        </button>
        <span className="text-white text-[11px] font-bold tabular-nums px-1 min-w-[38px] text-center">
          {String(index + 1).padStart(2, "0")}/{String(total).padStart(2, "0")}
        </span>
        <button
          onClick={(e) => { e.preventDefault(); next(); }}
          aria-label="Next"
          className="w-9 h-9 rounded-full grid place-items-center text-white bg-white/10 hover:bg-gradient-to-r hover:from-red-700 hover:to-orange-600 transition-all duration-300 hover:translate-x-0.5"
        >
          <IconChevronRight className="w-4 h-4" />
        </button>
      </div>

      {!paused && total > 1 && (
        <div
          key={index}
          className="absolute top-0 left-0 h-[3px] w-full origin-left bg-gradient-to-r from-red-700 via-orange-600 to-amber-500 animate-[kp-progress_5s_linear]"
        />
      )}

      {total > 1 && (
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-1.5">
          {items.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              aria-label={`Go to slide ${i + 1}`}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                i === index ? "w-6 bg-white" : "w-1.5 bg-white/40 hover:bg-white/70"
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
}

/* ------------------------------- view toggle -------------------------------- */


/* =========================================================================== *
 *  MAIN COMPONENT
 * =========================================================================== */

export default function GlobalPublications() {
  const [view, setView] = useState("grid"); // "grid" | "slider"
  const [page, setPage] = useState(1);
  const itemsPerPage = 6;

  const [allItems, setAllItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    (async () => {
      try {
        const data = await fetchKnowledgePublications({ all: true });
        if (cancelled) return;
        setAllItems(data.records);
      } catch (e) {
        if (!cancelled) setError("Couldn't load publications. Please try again.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, []);

  const totalPages = Math.max(1, Math.ceil(allItems.length / itemsPerPage));
  const pageItems = allItems.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  return (
    <section className="py-12 md:py-16 bg-[#FAF7F2]">
      <style>{`
        @keyframes kp-progress {
          from { transform: scaleX(0); }
          to { transform: scaleX(1); }
        }
      `}</style>

      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between gap-4 flex-wrap mb-6">
          <div>
            <div className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-[#B42318]">Global Hub</div>
            <h2 className="font-display text-2xl sm:text-3xl text-gray-900 mt-1">Publications</h2>
          </div>

         
        </div>

        {loading && (
          <div className="grid place-items-center py-20 text-gray-400 text-sm">Loading publications…</div>
        )}

        {!loading && error && (
          <div className="grid place-items-center py-20 text-red-600 text-sm">{error}</div>
        )}

        {!loading && !error && view === "grid" && (
          <>
            {allItems.length === 0 ? (
              <div className="grid place-items-center py-20 text-gray-400 text-sm">No publications found.</div>
            ) : (
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {pageItems.map((item) => (
                  <KnowledgeCard key={item.id} item={item} />
                ))}
              </div>
            )}
            <GridPagination page={page} totalPages={totalPages} onChange={setPage} />
          </>
        )}

        {!loading && !error && view === "slider" && <KnowledgeSlider items={allItems} />}
      </div>
    </section>
  );
}
